<app-navbar-style-one></app-navbar-style-one>

<div class="menu-page account-section">
    <div class="container-fluid">
        <div class="content-wrapper">
            <!-- Left Image -->
            <div class="left-image">
                <img src="../../../assets/img/home2/header1.jpg" alt="Chef seasoning steak">
            </div>

            <!-- Center Content -->
            <div class="center-content">
                <h2>{{ 'Offers' | titlecase}}</h2>
                <p>
                    Here’s your order so far! Double-check your dishes, adjust portions, or add something tasty before you checkout
                </p>
            </div>

            <!-- Right Images -->
            <div class="right-images">
                <img src="../../../assets/img/home2/header3.jpg" alt="Stuffed mushroom dish">
                <img src="../../../assets/img/home2/header2.jpg" alt="Gourmet burger with fries">
            </div>
        </div>
    </div>
</div>

<!-- Offers Section -->
<section class="offers-section">
    <div class="container">
        <!-- Loading Spinner -->
        <div class="row" *ngIf="isLoading">
            <div class="col-12 text-center">
                <div class="spinner-grow" role="status">
                    <span class="visually-hidden">Loading...</span>
                </div>
            </div>
        </div>

        <!-- Products Grid -->
        <div *ngIf="!isLoading" class="row">
            <div class="col-lg-4 col-md-6 mb-4" *ngFor="let item of subCategoryProducts">
                <div class="offer-card" [style.backgroundImage]="'url(' + item.avatar + ')'">
                    <div class="offer-content">
                        <a href="product-details/{{item.id}}/{{item.name}}">
                            <h3 class="offer-title">{{item.name}}</h3>
                        </a>
                        <p class="offer-description">{{item.components}}</p>
                        
                        <!-- Price Section -->
                        <div class="price-section">
                            <span class="price" *ngIf="item.offer && item.show_price == 1; else noOffer">
                                <!-- When offer exists -->
                                <span class="old-price text-white" *ngIf="(item.offer.type === 'percentage' || item.offer.type === 'discount') && item?.types[0]">
                                    {{item.types[0].price}} $
                                </span>
                                <span *ngIf="item?.types[0]" class="new-price text-white">
                                    {{ calculateDiscountedPrice(item) }} $
                                </span>
                            </span>
                            <span class="offer-badge">
                                {{ getOfferText(item.offer) }}
                            </span>
                            <ng-template #noOffer>
                                <span *ngIf="item.show_price == 1 && item?.types[0]" class="new-price">{{item.types[0].price}} $</span>
                            </ng-template>
                        </div>
                        
                        <div class="d-flex">
                            <!-- Favorite Button -->
                            <a (click)="toggleFav(item.id)" class="favorite-btn me-2">
                                <i class="bx bx-heart heart" 
                                [class.bxs-heart]="item.isFavorite || isFavorite(item.id)" 
                                ></i>
                            </a>
                            <!-- Order Button -->
                            <a href="product-details/{{item.id}}/{{item.name}}" class="cart-btn">
                                <i class="bx bx-cart"></i>
                            </a>
                        </div>
                    </div>
                </div>
            </div>
            
            <!-- No Products Message -->
            <div class="col-12 mt-3" *ngIf="subCategoryProducts.length == 0">
                <div class="alert alert-danger">
                    <strong>Oops!</strong> No Products Found
                </div>
            </div>
        </div>
    </div>
</section>

<!-- Pagination Controls -->
<div class="col-12 mt-4" *ngIf="subCategoryProducts.length > 0 && totalPages > 1">
  <nav aria-label="Page navigation">
    <ul class="pagination justify-content-center">
      <li class="page-item" [class.disabled]="currentPage === 1">
        <a class="page-link" (click)="goToPage(currentPage - 1)" aria-label="Previous">
          <span aria-hidden="true">&laquo;</span>
        </a>
      </li>
      
      <li class="page-item" *ngFor="let page of getPagesArray()" 
          [class.active]="page === currentPage">
        <a class="page-link" (click)="goToPage(page)">{{page}}</a>
      </li>
      
      <li class="page-item" [class.disabled]="currentPage === totalPages">
        <a class="page-link" (click)="goToPage(currentPage + 1)" aria-label="Next">
          <span aria-hidden="true">&raquo;</span>
        </a>
      </li>
    </ul>
  </nav>
  
  <div class="text-center text-muted mt-2">
    Showing page {{currentPage}} of {{totalPages}} ({{subCategoryProducts.length}} of {{totalItems}} items)
  </div>
</div>


<app-footer-style-two></app-footer-style-two>